module.exports = __webpack_public_path__ + "img/7.2acebda0.png";